import { useQuery } from '@apollo/client';
import { usePersonId } from 'src/components/providers/PersonIdProvider';
import { CLINIC_PRACTITIONERS_QUERY } from '../queries/clinicPractitioners';
export let ClinicPractitionerKind = /*#__PURE__*/function (ClinicPractitionerKind) {
  ClinicPractitionerKind["All"] = "ALL";
  ClinicPractitionerKind["Favorite"] = "FAVORITE";
  ClinicPractitionerKind["Inactive"] = "INACTIVE";
  ClinicPractitionerKind["Recent"] = "RECENT";
  return ClinicPractitionerKind;
}({});
const useClinicPractitioners = ({
  options
}) => {
  const personReferenceId = usePersonId();
  const {
    data,
    ...rest
  } = useQuery(CLINIC_PRACTITIONERS_QUERY, {
    ...options,
    variables: {
      personReferenceId,
      ...options.variables
    },
    skip: options.skip || !personReferenceId
  });
  return {
    data: data?.clinicPractitioners,
    ...rest
  };
};
export default useClinicPractitioners;